import App from 'app/app.js';
import { SESSION_STORAGE_KEYS } from './../constant/session-storage-keys';

function BreadcrumbService($location, SessionStorageService) {
  const MAX_CRUMBS = 4;
  const MIN_CRUMBS = 2;
  let navHistory = JSON.parse(SessionStorageService.get(SESSION_STORAGE_KEYS.NAV_HISTORY)) || [];

  const crumbs = {
    '/my-dashboard': { name: 'Dashboard', path: '/my-dashboard' },
    '/packages': { name: 'Packages', path: '/packages' },
    '/addon': { name: 'Add Ons', path: '/addon' },
    '/shopping-cart': { name: 'Cart', path: '/shopping-cart' },
    '/bundle-deals': { name: 'Bundle Deals', path: '/bundle-deals' },
    '/billing-info': { name: 'Shipping & Billing', path: '/billing-info' },
    '/payment-info': { name: 'Payment', path: '/payment-info' },
    '/review-order': { name: 'Order Review', path: '/review-order' }
  };

  const CUSTOMIZE_CRUMB = { name: 'Customize', path: '/customize' };

  const saveHistory = () => SessionStorageService.set(SESSION_STORAGE_KEYS.NAV_HISTORY, JSON.stringify(navHistory));

  const getBasePath = (path = '') => {
    if (typeof path !== 'string' || !path.trim()) {
      return '/';
    }
    const parts = path.split('/').filter(Boolean);
    return parts.length > 0 ? `/${parts[0]}` : '/';
  };

  const recordPage = (crumb) => {
    navHistory = navHistory.filter((c) => c.name !== crumb.name);
    navHistory.push(crumb);
    if (navHistory.length > MAX_CRUMBS) navHistory.shift();
    saveHistory();
  };

  const resolveParentCrumb = (path) => {
    if (path.startsWith('/package-detail') || path.startsWith('/cyop')) {
      return crumbs['/packages'];
    }
    if (path.startsWith('/addon-detail') || path.startsWith('/textPersonalizer')) {
      return crumbs['/addon'];
    }

    const basePath = getBasePath(path);
    return crumbs[basePath];
  };

  const isCustomizePage = (path) =>
    path.startsWith('/package-detail') ||
    path.startsWith('/cyop') ||
    path.startsWith('/addon-detail') ||
    path.startsWith('/textPersonalizer');

  this.updateBreadcrumbs = () => {
    const path = $location.path();

    if (path === '/billing-info') {
      navHistory = [crumbs['/shopping-cart'], crumbs['/billing-info']];
      saveHistory();
      return;
    }

    if (path === '/') {
      navHistory = [];
      saveHistory();
      return;
    }

    if (!isCustomizePage(path)) {
      navHistory = navHistory.filter((c) => c.name !== 'Customize');
    }

    const resolvedCrumb = resolveParentCrumb(path);

    if (resolvedCrumb) {
      recordPage(resolvedCrumb);
    }

    if (isCustomizePage(path)) {
      recordPage(CUSTOMIZE_CRUMB);
    }
  };

  this.getBreadcrumbs = () => {
    const path = $location.path();
    const resolvedCrumb = resolveParentCrumb(path);

    if (!resolvedCrumb || navHistory.length < MIN_CRUMBS) {
      return [];
    }

    return [...navHistory];
  };
}

App.service('BreadcrumbService', ['$location', 'SessionStorageService', BreadcrumbService]);
